import { SEC_TYPE } from 'const/stock'
import getOptionExpiryString from './getOptionExpiryString'

// 获取服务端期权拼接参数
export default function setOptionRequestParams(params, stock) {
  if (stock.secType === SEC_TYPE.OPT) {
    params.strike = stock.strike
    params.right = stock.right.toUpperCase()
    params.expiry = getOptionExpiryString(stock.expiry)
  }
  return params
}
